export default __webpack_public_path__ + "static/media/imgGift.28d0f9c9.png";